<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="row gx-5 gx-xl-10">
        <div class="card mb-5 mb-xl-8">
          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bold fs-3 mb-1">{{
                userId ? ("editUser" | translate) : ("createUser" | translate)
              }}</span>
            </h3>
          </div>
          <div class="card-body py-3">
            <form [formGroup]="userForm" (ngSubmit)="saveUser($event)">
              <div class="row mb-5 mt-5">
                <!-- Specialism -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <select
                      formControlName="specialisms"
                      class="form-select cursor-pointer"
                      id="inputSpecialism"
                      aria-label="Specialism"
                    >
                      <option [ngValue]="null" disabled>
                        {{ "selectSpecialism" | translate }}
                      </option>
                      <option
                        *ngFor="let specialism of specialismList"
                        [value]="specialism.id"
                      >
                        {{ specialism.name }}
                      </option>
                    </select>
                    <label for="inputSpecialism">
                      {{ "specialism" | translate }}
                    </label>
                    <div
                      *ngIf="isControlInvalid('specialisms')"
                      class="text-danger"
                    >
                      {{ "specialismRequired" | translate }}
                    </div>
                  </div>
                </div>
                <!-- Role -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <select
                      formControlName="roleId"
                      class="form-select cursor-pointer"
                      id="inputRole"
                      aria-label="Role"
                    >
                      <option [ngValue]="null" disabled>
                        {{ "selectRole" | translate }}
                      </option>
                      <option *ngFor="let role of roles" [value]="role.id">
                        {{ role.name }}
                      </option>
                    </select>
                    <label for="inputRole">
                      {{ "role" | translate }}
                    </label>
                    <div *ngIf="isControlInvalid('roleId')" class="text-danger">
                      {{ "roleRequired" | translate }}
                    </div>
                  </div>
                </div>
                <!-- Organization -->
                <!-- <ng-container> -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <select
                      formControlName="customerCode"
                      class="form-select cursor-pointer"
                      id="inputOrganization"
                      aria-label="Organization"
                      (change)="onChangeCustomerCode($event)"
                    >
                      <option [ngValue]="null" disabled>
                        {{ "selectOrganization" | translate }}
                      </option>
                      <option
                        *ngFor="let organization of organizationList"
                        [value]="organization.code"
                      >
                        {{ organization.code }}
                      </option>
                    </select>
                    <label for="inputOrganization">
                      {{ "organization" | translate }}
                    </label>
                    <div
                      *ngIf="isControlInvalid('customerCode')"
                      class="text-danger"
                    >
                      {{ "organizationRequired" | translate }}
                    </div>
                  </div>
                </div>
                <!-- </ng-container> -->
                <!-- Organization Branch-->
                <ng-container>
                  <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                    <div class="form-floating">
                      <select
                        formControlName="branchCode"
                        class="form-select cursor-pointer"
                        id="inputBranch"
                        aria-label="Branch"
                        (change)="onChangeSelectedBranch($event)"
                      >
                        <option [ngValue]="null" disabled>
                          {{ "selectBranch" | translate }}
                        </option>
                        <option
                          *ngFor="let branch of organizationBranchList"
                          [value]="branch.id"
                        >
                          {{ branch.name }}
                        </option>
                      </select>
                      <label for="inputBranch">
                        {{ "branch" | translate }}
                      </label>
                      <div
                        *ngIf="isControlInvalid('branchCode')"
                        class="text-danger"
                      >
                        {{ "branchRequired" | translate }}
                      </div>
                    </div>
                  </div>
                </ng-container>
                <!-- Name -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="name"
                      type="text"
                      class="form-control"
                      id="inputName"
                      placeholder="{{ 'name' | translate }}"
                      required
                    />
                    <label for="inputName">
                      {{ "name" | translate }}
                    </label>
                    <div *ngIf="isControlInvalid('name')" class="text-danger">
                      <ng-container
                        *ngIf="userForm.get('name')?.hasError('required')"
                      >
                        {{ "nameRequired" | translate }}
                      </ng-container>
                      <ng-container
                        *ngIf="
                          !userForm.get('name')?.hasError('required') &&
                          userForm.get('name')?.hasError('onlyLetters')
                        "
                      >
                        {{ "nameMustContainOnlyLetters" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- Surname -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="surname"
                      type="text"
                      class="form-control"
                      id="inputSurname"
                      placeholder="{{ 'surname' | translate }}"
                    />
                    <label for="inputSurname">
                      {{ "surname" | translate }}
                    </label>
                    <div
                      *ngIf="isControlInvalid('surname')"
                      class="text-danger"
                    >
                      <ng-container
                        *ngIf="userForm.get('surname')?.hasError('required')"
                      >
                        {{ "surnameRequired" | translate }}
                      </ng-container>
                      <ng-container
                        *ngIf="
                          !userForm.get('surname')?.hasError('required') &&
                          userForm.get('surname')?.hasError('onlyLetters')
                        "
                      >
                        {{ "surnameMustContainOnlyLetters" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- PID -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="pid"
                      type="text"
                      class="form-control"
                      id="inputPid"
                      placeholder="PID"
                    />
                    <label for="inputPid">
                      {{ "agbCode" | translate }}
                    </label>
                    <div *ngIf="isControlInvalid('pid')" class="text-danger">
                      <div *ngIf="userForm.get('pid')?.errors?.['required']">
                        {{ "pidRequired" | translate }}
                      </div>
                      <div *ngIf="userForm.get('pid')?.errors?.['minlength']">
                        {{ "pidMustBeAtLeast6CharactersLong" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Date of Birth -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="dateOfBirth"
                      type="date"
                      class="form-control"
                      id="inputDob"
                      placeholder="Date of Birth"
                      [max]="maxDate"
                    />
                    <label for="inputDob">
                      {{ "dateOfBirth" | translate }}
                    </label>
                    <div
                      *ngIf="isControlInvalid('dateOfBirth')"
                      class="text-danger"
                    >
                      {{ "dateOfBirthRequired" | translate }}
                    </div>
                  </div>
                </div>
                <!-- Phone Number -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="phoneNumber"
                      type="tel"
                      class="form-control"
                      id="inputTel"
                      placeholder="Tel. number"
                    />
                    <label for="inputTel">
                      {{ "phoneNumber" | translate }}
                    </label>
                    <div
                      *ngIf="isControlInvalid('phoneNumber')"
                      class="text-danger"
                    >
                      <div
                        *ngIf="userForm.get('phoneNumber')?.errors?.['required']"
                      >
                        {{ "phoneNumberRequired" | translate }}
                      </div>
                      <div
                        *ngIf="userForm.get('phoneNumber')?.errors?.['pattern']"
                      >
                        {{ "phoneNumberNotValid" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Email -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="email"
                      type="email"
                      class="form-control"
                      id="inputEmail"
                      placeholder="Email"
                    />
                    <label for="inputEmail">
                      {{ "email" | translate }}
                    </label>
                    <div *ngIf="isControlInvalid('email')" class="text-danger">
                      <div *ngIf="userForm.get('email')?.errors?.['required']">
                        {{ "emailRequired" | translate }}
                      </div>
                      <div *ngIf="userForm.get('email')?.errors?.['email']">
                        {{ "emailNotValid" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-8 gap-3">
                <button
                  [routerLink]="['/user/list']"
                  type="button"
                  class="btn btn-sm btn-secondary cursor-pointer"
                >
                  {{ "cancel" | translate }}
                </button>
                <button
                  type="submit"
                  class="btn btn-sm btn-dark cursor-pointer"
                >
                  {{ "save" | translate }}
                  <i class="ki-duotone ki-arrow-right fs-2x"></i>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
